// OUTDATED VERSION
// Now we are using approach to play all in one.

import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { COLORS } from "../../constants"
import { useHistory } from "react-router-dom"
import { CustomButton, BackButton } from "../../components"

import axios from "axios"
import styled from "styled-components"

const StyledCardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
    margin-top: 10px;
`;
const StyledWhiteCard = styled.div`
    background-color: white;
    border-radius: 10px;
    display: flex;
    color: black;
    padding: 10px;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    height: 150px;
`;

const StyledWrapper = styled.div`
   padding: 10px;
`;

export default function TryAgain(props) {
    const api = process.env.REACT_APP_API_URL;
    const history = useHistory();

    const user = useSelector(state => state.auth.user.user)
    const [tryGames, setTryGames] = useState(null)

    const { levelno } = props.match.params;


    useEffect(async () => {
        const response = await axios.get(`${api}/ts/cp_retry_games_questions/${user.pupil_id}/${levelno}`);
        const data = await response.data.data;
        setTryGames(data)
        console.log(data)

    }, [])
    const startTryAgain = async (gameno) => {

        const newGame = {
            pupil_id: user.pupil_id,
            level_no: levelno,
            game_no: gameno,
            mode_id: 2
        }

        try {
            const response = await axios.post(`${api}/cp/game/new_game`, newGame);
            const result = await response.data;
            if (result.status == "error") {


                alert('You cannot play this game again.')
                console.log(result)
            }
            else

                history.replace(`/try_again_game/${levelno}/${gameno}/current_game/${result.new_game_id}`)

        } catch (err) {
            alert("OOPS, error occured. Try to reload a page.")
        }
    }
    return (
        <div>
            <BackButton onClick={() => history.goBack()} />
            <h5 className="color-text-dark-blue mb-0 text-center">Try Again Level {levelno} Games </h5>
            <StyledCardContainer>
                {tryGames != null && tryGames.map((game, i) => {
                    return <StyledWrapper className="xs-grid-card" key={i}>
                        <StyledWhiteCard>
                            <h5 className="mb-0">Game {game.game_no}</h5>
                            <div className="color-text-grey">{game.questions} Questions</div>
                            <CustomButton className="w-75" bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} onClick={() => startTryAgain(game.game_no)}>
                                Play
                            </CustomButton>
                        </StyledWhiteCard>
                    </StyledWrapper>
                })}
            </StyledCardContainer>
        </div>
    )
}
